import React, { FC } from 'react';

import HowBrandWorksSection from '@rover/react-lib/src/components/HowBrandWorksSection';

const HomePageHowBrandWorks: FC = () => {
  return <HowBrandWorksSection py={['0x', '8x']} mt={['8x', '8x', '0x']} />;
};

export default HomePageHowBrandWorks;
